export default '1.1.2';



// WEBPACK FOOTER //
// ./version.js